import axios from 'axios';
import envConfig from '../envConfig';

const api = axios.create({
  baseURL: envConfig.ApiUrl,
  headers: {
    'Ocp-Apim-Subscription-Key': envConfig.ApiKey
  },
  timeout: 2700000
});

api.interceptors.request.use(
  (request) => {
    if (request) {
      request.headers['Accept-Language'] = `${window?.localStorage?.getItem(`${envConfig.StoragePrefix}-lang`)}-US`.replaceAll('"', '');
      request.headers.Authorization = `Bearer ${window?.localStorage?.getItem(`${envConfig.StoragePrefix}-token`)}`.replaceAll('"', '');
    }
    return request;
  }, function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
